import { useParams } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import useAppGroup from '../../helpers/hooks/useAppGroup';
import PosPagesTable from './PosPagesTable.react';
import PpcPagesTable from './PpcPagesTable.react';
import SubHeader from '../header/SubHeader.react';

// TODO :: Stop if app / type is not in constants
var Pages = function Pages() {
  var _useParams = useParams(),
    app = _useParams.app,
    itemID = _useParams.itemID;
  var appGroup = useAppGroup({
    app: app
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SubHeader, {
    route: "pages"
  }), /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, itemID && /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(NavLink, {
    className: "page__content--back",
    to: "/".concat(app, "/pages")
  }, "View All")), appGroup === 'pos' && /*#__PURE__*/React.createElement(PosPagesTable, null), appGroup === 'ppc' && /*#__PURE__*/React.createElement(PpcPagesTable, null)));
};
export default Pages;